module.exports = __webpack_public_path__ + "static/media/judo.053874cf.jpg";